// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parent-grid-container {
    width: 85%;
    height: 80vh;
    /* background-color: red; */
    box-sizing: border-box;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-left: 10px;
    /* Corrected property name */
}

.parent-grid-container::-webkit-scrollbar {
    width: 10px;
    background-color: #1e1e1e;
}

.parent-grid-container::-webkit-scrollbar-thumb {
    background-color: #3a3939;
    border-radius: 5%;
    width: 5px;
    height: 10px;
}

.grid-container {
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto 50px;
    width: 97%;
    /* height: 100%; */
    /* Set height to 100% to fill the parent container */
}

.grid-item {
    /* border: 1px solid rgba(0, 0, 0, 0.8); */
    text-align: center;
    box-sizing: border-box;
}


.update-psd-logout-button {
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;

}

.left-extended-profile {
    width: 100%;
    height: 100%;
    background: #333333 0% 0% no-repeat padding-box;
    border-radius: 10px;
    opacity: 1;
    /* position: absolute;
    top: 10%; */
}


.left-toolbar-profile-container {
    width: 100%;
    height: 100%;
    background: #333333 0% 0% no-repeat padding-box;
    border-radius: 10px;
    opacity: 1;
    /* position: absolute;
    top: 52%; */
}




.td-profile {
    width: 54%;
    padding: 5px;
    text-align: left;
    font: normal normal normal 0.8125rem/1.25rem Roboto;
    /* Optional: Add padding to the table cells for better spacing */
}

.table-profile {
    border-collapse: collapse;
    border-spacing: 0;
    width: 90%;
    /* Set the gap between rows to zero */
}

.card-header {
    font-weight: bold;
    height: 26px;
    text-align: center;
    font: normal normal normal 1.5rem Roboto;
    letter-spacing: 0px;
    color: #C6C4C4;
    opacity: 1;
    margin-bottom: 10px;
}



.edit-profile-btn {
    width: 150px;
    height: 37px;
    border: 1px solid #589500;
    border-radius: 5px;
    opacity: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    width: 150px;
    height: 37px;
    border: 1px solid #589500;
    border-radius: 5px;
    opacity: 1;

}

.edit-profile-button-text {
    width: 150px;
    height: 22px;
    text-align: center;
    font: normal normal normal 15px/20px Roboto;
    letter-spacing: 0px;
    color: #FFFFFF;
    opacity: 1;
}

.edit-profile-btn:hover {
    /* // background-color: #0056b3;
    // color: #fff; */
}

.email,
.member-since,
.phone {
    font-size: 0.8rem;
    margin-bottom: 5px;
}

.name {
    font-size: 1rem;
    margin-bottom: 10px;
    font-weight: bold;
}

.profile-image-upload-container {
    width: 100%;
    margin-bottom: 10px;
}


.profile-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    height: 26px;
    text-align: center;
    font: normal normal normal 15px/26px Roboto;
    letter-spacing: 0px;
    color: #EBEBEB;
    opacity: 1;
}

.profile-text-grey {
    width: 100%;
    height: 20px;
    text-align: center;
    font: normal normal normal 15px/20px Roboto;
    letter-spacing: 0px;
    color: #A49E9E;
    margin-bottom: 5px;
}

.td-profile-name {
    width: 54%;
    text-align: left;
    font: normal normal normal 0.8125rem/1.25rem Roboto;
    letter-spacing: 0px;
    color: #FFFFFF;
    text-transform: uppercase;
    opacity: 1;
}

.td-profile-exp {
    display: flex;
    width: 115px;
    text-align: right;
    font: normal normal normal 0.8125rem/1.25rem Roboto;
    letter-spacing: 0px;
    color: #C6C4C4;
    opacity: 1;
}

.td-profile-created-on {
    width: 110px;
    text-align: left;
    font: normal normal normal 0.8125rem/1.25rem Roboto;
    letter-spacing: 0px;
    color: #C6C4C4;
    opacity: 1;
}

.table-container {
    margin-bottom: 5px;
    margin-top: 5px;
}

.confirm-subscription-removal-container {
    position: fixed;
    width: 350px;
    height: 200px;
    top: 40%;
    left: 50%;
    background-color: rgba(0, 0, 0, 0.8);
    padding: 20px;
    box-sizing: border-box;
    z-index: 1234;
    border-radius: 8px;
}

.no-membership-container {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.membership-upgeade-button {
    width: 115px;
    height: 40px;
}

.logout-button {
    width: 100%;
    max-width: 200px;
    margin: 10px auto;
    z-index: 9999;
}

.logout-button-container {
    width: 100%;
    background-color: #030200;
    position: absolute;
    bottom: 7vh;
    height: 50px;
}


.upgrade-membership-container {
    color: red;
    display: flex;
    flex-direction: column;
    /* border: 1px solid rgb(81, 46, 42); */
    width: 100%;
    color: #333333
}

.active-subscription-container {
    display: flex;
    justify-content: space-around;
}

.item-style {
    display: flex;
    justify-content: start;
    align-items: center;
    width: 65%;
}

.item-style-two {
    display: flex;
    justify-content: start;
    align-items: center;
    width: 125px;
}


.membership-update-button {
    width: 60px;
    height: 25px;
    font-size: 12px;
    margin: 0em;
    margin-bottom: 10px;
}

.text-style-update {
    text-align: left;
    font: normal normal normal 0.8125rem / 1.25rem Roboto;
    letter-spacing: 0px;
    color: #FFFFFF;
    /* text-transform: uppercase; */
    opacity: 1;
    margin-left: 11px;
}

.upgrade-box-container {
    width: 90vh;
    height: 90vh;
    background-color: rgb(43, 43, 43);
    box-sizing: border-box;
    border-radius: 8px;
    padding: 20px;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
}

.close-icon-update {
    color: white;
    cursor: pointer;
    font-size: 15px;
    font-size: 30px;
    text-align: end;
    position: relative;
    bottom: 50%;
    left: 50%;
}

.upgrade-container {
    width: 90%;
    height: 90%;
    background-color: rgb(43, 43, 43);
    border-radius: 20px;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
}

.upgrade-item-container {
    width: 90%;
    height: 100px;

    border-radius: 20px;
    margin-bottom: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 15px;
}

.child-container-style {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.child-container-style-two {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: baseline;
}

.header-style {
    font-size: 1.5rem !important;
    font-weight: 700 !important;
}

.fw-normal {
    font-weight: 400 !important;
}

.fs-6 {
    font-size: 1rem !important;
}

.price-value-style {
    font-weight: 400 !important;
    font-size: 1rem !important;
    margin: 0.3rem;
}

.selected {
    border: 2px solid rgb(88, 149, 0);
}

.fc-white {
    color: #fff;
}

.fc-grey {
    color: #C6C4C4;
}


.radio {
    position: relative;
    width: 100px;
    /* Adjust as needed */
    height: 100px;
    /* Adjust as needed */
    border: 1px solid #ccc;
    cursor: pointer;
    background-color: #fff;
    /* Default background color */
    transition: all 0.3s ease;
}

.radio-button {
    border-radius: 50%;
    height: 20px;
    width: 20px;
}

.image-style {
    width: 20px;
    height: 20px;
}

.d-none {
    display: none;
    /* Hides the input element */
}

.main-header-style {
    position: relative;
    bottom: 5%;
    font-size: 30px;
    font-weight: 500;
}

.upgrade-button-style {
    width: 200px;
    height: 40px;
}

.upgraded {
    border: 2px solid #808080;
}

.selected {
    border: 2px solid rgb(88, 149, 0);
}`, "",{"version":3,"sources":["webpack://./src/component/main-ui/left-toolbar/profile/index.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;IACZ,2BAA2B;IAC3B,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,6BAA6B;IAC7B,UAAU;IACV,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,sBAAsB;AAC1B;;;AAGA;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+CAA+C;IAC/C,mBAAmB;IACnB,UAAU;IACV;eACW;AACf;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,+CAA+C;IAC/C,mBAAmB;IACnB,UAAU;IACV;eACW;AACf;;;;;AAKA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,mDAAmD;IACnD,gEAAgE;AACpE;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,UAAU;IACV,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,mBAAmB;AACvB;;;;AAIA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;;AAEd;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;IACI;qBACiB;AACrB;;AAEA;;;IAGI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;;AAGA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,mDAAmD;IACnD,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,mDAAmD;IACnD,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mDAAmD;IACnD,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uCAAuC;IACvC,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;AAChB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,qDAAqD;IACrD,mBAAmB;IACnB,cAAc;IACd,+BAA+B;IAC/B,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;IACf,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iCAAiC;IACjC,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;;IAEb,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,sBAAsB;IACtB,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;AACrC","sourcesContent":[".parent-grid-container {\n    width: 85%;\n    height: 80vh;\n    /* background-color: red; */\n    box-sizing: border-box;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    margin-left: 10px;\n    /* Corrected property name */\n}\n\n.parent-grid-container::-webkit-scrollbar {\n    width: 10px;\n    background-color: #1e1e1e;\n}\n\n.parent-grid-container::-webkit-scrollbar-thumb {\n    background-color: #3a3939;\n    border-radius: 5%;\n    width: 5px;\n    height: 10px;\n}\n\n.grid-container {\n    display: grid;\n    grid-template-columns: auto;\n    grid-template-rows: auto 50px;\n    width: 97%;\n    /* height: 100%; */\n    /* Set height to 100% to fill the parent container */\n}\n\n.grid-item {\n    /* border: 1px solid rgba(0, 0, 0, 0.8); */\n    text-align: center;\n    box-sizing: border-box;\n}\n\n\n.update-psd-logout-button {\n    height: 100px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.left-extended-profile {\n    width: 100%;\n    height: 100%;\n    background: #333333 0% 0% no-repeat padding-box;\n    border-radius: 10px;\n    opacity: 1;\n    /* position: absolute;\n    top: 10%; */\n}\n\n\n.left-toolbar-profile-container {\n    width: 100%;\n    height: 100%;\n    background: #333333 0% 0% no-repeat padding-box;\n    border-radius: 10px;\n    opacity: 1;\n    /* position: absolute;\n    top: 52%; */\n}\n\n\n\n\n.td-profile {\n    width: 54%;\n    padding: 5px;\n    text-align: left;\n    font: normal normal normal 0.8125rem/1.25rem Roboto;\n    /* Optional: Add padding to the table cells for better spacing */\n}\n\n.table-profile {\n    border-collapse: collapse;\n    border-spacing: 0;\n    width: 90%;\n    /* Set the gap between rows to zero */\n}\n\n.card-header {\n    font-weight: bold;\n    height: 26px;\n    text-align: center;\n    font: normal normal normal 1.5rem Roboto;\n    letter-spacing: 0px;\n    color: #C6C4C4;\n    opacity: 1;\n    margin-bottom: 10px;\n}\n\n\n\n.edit-profile-btn {\n    width: 150px;\n    height: 37px;\n    border: 1px solid #589500;\n    border-radius: 5px;\n    opacity: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-decoration: none;\n    width: 150px;\n    height: 37px;\n    border: 1px solid #589500;\n    border-radius: 5px;\n    opacity: 1;\n\n}\n\n.edit-profile-button-text {\n    width: 150px;\n    height: 22px;\n    text-align: center;\n    font: normal normal normal 15px/20px Roboto;\n    letter-spacing: 0px;\n    color: #FFFFFF;\n    opacity: 1;\n}\n\n.edit-profile-btn:hover {\n    /* // background-color: #0056b3;\n    // color: #fff; */\n}\n\n.email,\n.member-since,\n.phone {\n    font-size: 0.8rem;\n    margin-bottom: 5px;\n}\n\n.name {\n    font-size: 1rem;\n    margin-bottom: 10px;\n    font-weight: bold;\n}\n\n.profile-image-upload-container {\n    width: 100%;\n    margin-bottom: 10px;\n}\n\n\n.profile-text {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n    height: 26px;\n    text-align: center;\n    font: normal normal normal 15px/26px Roboto;\n    letter-spacing: 0px;\n    color: #EBEBEB;\n    opacity: 1;\n}\n\n.profile-text-grey {\n    width: 100%;\n    height: 20px;\n    text-align: center;\n    font: normal normal normal 15px/20px Roboto;\n    letter-spacing: 0px;\n    color: #A49E9E;\n    margin-bottom: 5px;\n}\n\n.td-profile-name {\n    width: 54%;\n    text-align: left;\n    font: normal normal normal 0.8125rem/1.25rem Roboto;\n    letter-spacing: 0px;\n    color: #FFFFFF;\n    text-transform: uppercase;\n    opacity: 1;\n}\n\n.td-profile-exp {\n    display: flex;\n    width: 115px;\n    text-align: right;\n    font: normal normal normal 0.8125rem/1.25rem Roboto;\n    letter-spacing: 0px;\n    color: #C6C4C4;\n    opacity: 1;\n}\n\n.td-profile-created-on {\n    width: 110px;\n    text-align: left;\n    font: normal normal normal 0.8125rem/1.25rem Roboto;\n    letter-spacing: 0px;\n    color: #C6C4C4;\n    opacity: 1;\n}\n\n.table-container {\n    margin-bottom: 5px;\n    margin-top: 5px;\n}\n\n.confirm-subscription-removal-container {\n    position: fixed;\n    width: 350px;\n    height: 200px;\n    top: 40%;\n    left: 50%;\n    background-color: rgba(0, 0, 0, 0.8);\n    padding: 20px;\n    box-sizing: border-box;\n    z-index: 1234;\n    border-radius: 8px;\n}\n\n.no-membership-container {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n}\n\n.membership-upgeade-button {\n    width: 115px;\n    height: 40px;\n}\n\n.logout-button {\n    width: 100%;\n    max-width: 200px;\n    margin: 10px auto;\n    z-index: 9999;\n}\n\n.logout-button-container {\n    width: 100%;\n    background-color: #030200;\n    position: absolute;\n    bottom: 7vh;\n    height: 50px;\n}\n\n\n.upgrade-membership-container {\n    color: red;\n    display: flex;\n    flex-direction: column;\n    /* border: 1px solid rgb(81, 46, 42); */\n    width: 100%;\n    color: #333333\n}\n\n.active-subscription-container {\n    display: flex;\n    justify-content: space-around;\n}\n\n.item-style {\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    width: 65%;\n}\n\n.item-style-two {\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    width: 125px;\n}\n\n\n.membership-update-button {\n    width: 60px;\n    height: 25px;\n    font-size: 12px;\n    margin: 0em;\n    margin-bottom: 10px;\n}\n\n.text-style-update {\n    text-align: left;\n    font: normal normal normal 0.8125rem / 1.25rem Roboto;\n    letter-spacing: 0px;\n    color: #FFFFFF;\n    /* text-transform: uppercase; */\n    opacity: 1;\n    margin-left: 11px;\n}\n\n.upgrade-box-container {\n    width: 90vh;\n    height: 90vh;\n    background-color: rgb(43, 43, 43);\n    box-sizing: border-box;\n    border-radius: 8px;\n    padding: 20px;\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.close-icon-update {\n    color: white;\n    cursor: pointer;\n    font-size: 15px;\n    font-size: 30px;\n    text-align: end;\n    position: relative;\n    bottom: 50%;\n    left: 50%;\n}\n\n.upgrade-container {\n    width: 90%;\n    height: 90%;\n    background-color: rgb(43, 43, 43);\n    border-radius: 20px;\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-top: 20px;\n}\n\n.upgrade-item-container {\n    width: 90%;\n    height: 100px;\n\n    border-radius: 20px;\n    margin-bottom: 60px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    padding: 15px;\n}\n\n.child-container-style {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.child-container-style-two {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: baseline;\n}\n\n.header-style {\n    font-size: 1.5rem !important;\n    font-weight: 700 !important;\n}\n\n.fw-normal {\n    font-weight: 400 !important;\n}\n\n.fs-6 {\n    font-size: 1rem !important;\n}\n\n.price-value-style {\n    font-weight: 400 !important;\n    font-size: 1rem !important;\n    margin: 0.3rem;\n}\n\n.selected {\n    border: 2px solid rgb(88, 149, 0);\n}\n\n.fc-white {\n    color: #fff;\n}\n\n.fc-grey {\n    color: #C6C4C4;\n}\n\n\n.radio {\n    position: relative;\n    width: 100px;\n    /* Adjust as needed */\n    height: 100px;\n    /* Adjust as needed */\n    border: 1px solid #ccc;\n    cursor: pointer;\n    background-color: #fff;\n    /* Default background color */\n    transition: all 0.3s ease;\n}\n\n.radio-button {\n    border-radius: 50%;\n    height: 20px;\n    width: 20px;\n}\n\n.image-style {\n    width: 20px;\n    height: 20px;\n}\n\n.d-none {\n    display: none;\n    /* Hides the input element */\n}\n\n.main-header-style {\n    position: relative;\n    bottom: 5%;\n    font-size: 30px;\n    font-weight: 500;\n}\n\n.upgrade-button-style {\n    width: 200px;\n    height: 40px;\n}\n\n.upgraded {\n    border: 2px solid #808080;\n}\n\n.selected {\n    border: 2px solid rgb(88, 149, 0);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
